import { useCreateTerminKalenderForm } from '@/domain/termine/features/CreateTerminKalender/shared/hooks/useCreateTerminKalenderForm';
import { CreateTerminKalenderFormContent } from '@/domain/termine/features/CreateTerminKalender/shared/CreateTerminKalenderFormContent';
import { CreateTerminKalenderFormContext } from '@/domain/termine/features/CreateTerminKalender/shared/CreateTerminKalenderFormContext';
import { useTranslation } from 'react-i18next';

type CreateTerminKalenderSheetFormProps = {
  form: ReturnType<typeof useCreateTerminKalenderForm>;
  onSubmitSuccess: () => void;
};

export function CreateTerminKalenderSheetForm({
  form,
  onSubmitSuccess,
}: CreateTerminKalenderSheetFormProps) {
  const { t } = useTranslation();

  return (
    <CreateTerminKalenderFormContext.Provider value={form}>
      <form.AppForm>
        <form
          className="flex flex-col flex-1 overflow-hidden"
          onSubmit={async (e) => {
            e.preventDefault();
            await form.handleSubmit();
            if (form.state.isSubmitSuccessful) onSubmitSuccess();
          }}>
          <div className="flex-1 overflow-y-auto">
            <CreateTerminKalenderFormContent />
          </div>
          <hr className="h-px bg-neutrals-300 border-0" />
          <div className="flex justify-end gap-2 py-4 px-6">
            <form.SubmitButton
              buttonText={t('domain.termine.form.fertig')}
              size="sm"
            />
          </div>
        </form>
      </form.AppForm>
    </CreateTerminKalenderFormContext.Provider>
  );
}
